export default __webpack_public_path__ + "static/media/delete-cross.5d333662.svg";